module.exports = window["wp"]["richText"];